import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type UserHasNoAccessToFeatureErrorOptions = {
  user: ObjectId;
  feature: { name: string };
};

export class UserHasNoAccessToFeatureError extends FleekError<UserHasNoAccessToFeatureErrorOptions> {
  public name = 'UserHasNoAccessToFeatureError';

  toString = () => `User has no access to this feature.`;
}
